/* main.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./main.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { di } from 'react-magnetic-di';
import { Box } from '@atlaskit/primitives/compiled';
import { setHubBrandingStyle, useHubContext, useUnsetGlobalTheme } from '@atlassian/company-hub-common';
import { Banner } from './banner';
import { Navbar } from './navbar';
var containerStyles = {
  bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
  container: "_19itglyw _2rko1mok _1reo1wug _18m91wug _vchhusvi _r06hglyw _kqswh2mm _16qs1cd0 _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4 _1r6i1fxt _rdbh1fxt"
};
export var HubAppShell = function HubAppShell(_ref) {
  var _branding$colors;
  var children = _ref.children,
    _ref$isEditMode = _ref.isEditMode,
    isEditMode = _ref$isEditMode === void 0 ? false : _ref$isEditMode;
  var _useHubContext = useHubContext(),
    layout = _useHubContext.layout,
    branding = _useHubContext.branding;
  var showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
  var primaryColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
  React.useEffect(function () {
    // we are targing whole document for branding style, because we need these variables in react portals as well, e.g. color picker
    return setHubBrandingStyle({
      primaryColor: primaryColor
    });
  }, [primaryColor]);
  var hubContainerRef = React.useRef(null);
  useUnsetGlobalTheme(isEditMode ? hubContainerRef.current : null); // for view mode we don't need to unset the global theme

  return /*#__PURE__*/React.createElement(Box, {
    xcss: containerStyles.container,
    ref: hubContainerRef
  }, /*#__PURE__*/React.createElement(Navbar, {
    isEditMode: isEditMode
  }), showBanner && /*#__PURE__*/React.createElement("div", {
    className: ax([containerStyles.bannerContainer])
  }, /*#__PURE__*/React.createElement(Banner, null)), children);
};